"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKILLS = exports.SKILL_TYPE = exports.SKILL_NAMES = exports.SKILL_MIGRATION_2025 = exports.SKILL_IS_2025 = exports.SKILL_INFO_INACTIVE = exports.SKILL_INFO_ACTIVE = exports.SKILL_DURATION = exports.isSpecialSkill = exports.isSelectPlayersSkills = exports.isActivableSkills = exports.helpSkillsToDisplay = exports.hasToAgilityJumpUp = exports.hasSkillForPlayer = exports.hasSkillDisplayableInfo = exports.getPlayersWithSkill = exports.BIG_GUY_LIMIT = void 0;
exports.getDisturbingPresenceMalus = getDisturbingPresenceMalus;
exports.getNoTurnoverSkill = getNoTurnoverSkill;
exports.getSkill = getSkill;
exports.getSkillDisplayedWithCarrer = getSkillDisplayedWithCarrer;
exports.getSkillLimitSizeTeam = getSkillLimitSizeTeam;
exports.getSpecialistLimit = getSpecialistLimit;
exports.getStarLimit = getStarLimit;
exports.hasSkill = hasSkill;
exports.hasUsedSkill = hasUsedSkill;
exports.isNoTurnoverSkill = isNoTurnoverSkill;
exports.useSkill = useSkill;
const newSkills_1 = require("./2025/newSkills");
const calcul_1 = require("./calcul");
const status_1 = require("./status");
const time_1 = require("./time");
const BIG_GUY_LIMIT = 1;
exports.BIG_GUY_LIMIT = BIG_GUY_LIMIT;
const STAR_LIMIT = 4;
const SPECIALIST_LIMIT = 6;
const SKILL_INFO_ACTIVE = "active";
exports.SKILL_INFO_ACTIVE = SKILL_INFO_ACTIVE;
const SKILL_INFO_INACTIVE = "inactive";
exports.SKILL_INFO_INACTIVE = SKILL_INFO_INACTIVE;
const SKILL_DURATION = {
    HALF_TIME: 1,
    NEXT_SETUP: 2,
    END_GAME: 3,
    WEAPON: 4,
};
exports.SKILL_DURATION = SKILL_DURATION;
// TODO
// Timmm-ber!
// SKILL_NAMES.SIDE_STEP, // +1push et +1mouv?
// Swarming // il en faut autant sur le terrain
// Missing for races
var SKILL_NAMES;
(function (SKILL_NAMES) {
    SKILL_NAMES["ACCURATE"] = "accurate";
    SKILL_NAMES["ALWAYS_HUNGRY"] = "always-hungry";
    SKILL_NAMES["ANIMAL_SAVAGERY"] = "animal-salvagery";
    SKILL_NAMES["ANIMOSITY"] = "animosity";
    SKILL_NAMES["ARM_BAR"] = "arm-bar";
    // BALL_AND_CHAIN = "ball-and-chain",
    SKILL_NAMES["BIG_GUY"] = "big-guy";
    SKILL_NAMES["BIG_HAND"] = "big-hand";
    SKILL_NAMES["BLOCK"] = "block";
    SKILL_NAMES["BLOODLUST"] = "bloodlust";
    SKILL_NAMES["BONE_HEAD"] = "bone-head";
    // BOMBARDIER = "bombardier",
    SKILL_NAMES["BRAWLER"] = "brawler";
    SKILL_NAMES["BREATHE_FIRE"] = "breathe-fire";
    SKILL_NAMES["BREAK_TACKLE"] = "break-tackle";
    SKILL_NAMES["BULLSEYE"] = "bullseye";
    SKILL_NAMES["CANNONEER"] = "cannoneer";
    SKILL_NAMES["CATCH"] = "catch";
    SKILL_NAMES["CHAINSAW"] = "chainsaw";
    SKILL_NAMES["CLAW"] = "claw";
    SKILL_NAMES["CLOUD_BURSTER"] = "cloud-burster";
    SKILL_NAMES["DAUNTLESS"] = "dauntless";
    SKILL_NAMES["DECAY"] = "decay";
    SKILL_NAMES["DEFENSIVE"] = "defensive";
    SKILL_NAMES["DIRTY_PLAYER"] = "dirty-player";
    SKILL_NAMES["DISTURBING_PRESENCE"] = "distrubing-presence";
    SKILL_NAMES["DIVING_TACKLE"] = "diving-tackle";
    SKILL_NAMES["DODGE"] = "dodge";
    SKILL_NAMES["DRUNKARD"] = "drunkard";
    SKILL_NAMES["DUMP_OFF"] = "dump-off";
    SKILL_NAMES["EYE_GOUGE"] = "eye-gouge";
    SKILL_NAMES["EXTRA_ARMS"] = "extra-arms";
    SKILL_NAMES["FEND"] = "fend";
    SKILL_NAMES["FOUL_APPEARANCE"] = "foul-appearance";
    SKILL_NAMES["FRENZY"] = "frenzy";
    SKILL_NAMES["FUMBLEROOSKIE"] = "fumblerooskie";
    SKILL_NAMES["GRAB"] = "grab";
    SKILL_NAMES["HAIL_MARY_PASS"] = "hail-mary-pass";
    // HATRED = "hatred",
    SKILL_NAMES["GUARD"] = "guard";
    SKILL_NAMES["HIT_AND_RUN"] = "hit-and-run";
    SKILL_NAMES["HORNS"] = "horns";
    SKILL_NAMES["HYPNOTIC_GAZE"] = "hypnotic-gaze";
    // INSIGNIFICANT = "insignificant",
    SKILL_NAMES["IRON_HARD_SKIN"] = "iron-hard-skin";
    SKILL_NAMES["JUGGERNAUT"] = "juggernaut";
    SKILL_NAMES["JUMP_UP"] = "jump-up";
    // KICK = "kick",
    // KICK_TEAMMATE = "kick-teammate",
    // LETHAL_FLIGHT = "lethal-flight",
    // LEADER = "leader",
    SKILL_NAMES["LEAP"] = "leap";
    SKILL_NAMES["LONE_FOULER"] = "lone-fouler";
    SKILL_NAMES["LONER"] = "loner";
    SKILL_NAMES["MIGHTY_BLOW"] = "mighty-blow";
    SKILL_NAMES["MONSTROUS_MOUTH"] = "monstrous-mouth";
    SKILL_NAMES["MY_BALL"] = "my-ball";
    // MULTIPLE_BLOCK = "multiple-block",
    SKILL_NAMES["NERVES_OF_STEEL"] = "nerves-of-steel";
    SKILL_NAMES["NO_HANDS"] = "no-hand";
    SKILL_NAMES["ON_THE_BALL"] = "on-the-ball";
    SKILL_NAMES["PASS"] = "pass";
    SKILL_NAMES["PILE_DRIVER"] = "pile-driver";
    SKILL_NAMES["PICK_ME_UP"] = "pick-me-up";
    SKILL_NAMES["PLAGUE_RIDDEN"] = "plague-ridden";
    SKILL_NAMES["PUNT"] = "punt";
    SKILL_NAMES["PRO"] = "pro";
    SKILL_NAMES["PUT_THE_BOOT_IN"] = "put-the-boot-in";
    SKILL_NAMES["POGO_STICK"] = "pogo-stick";
    SKILL_NAMES["PREHENSILE_TAIL"] = "prehensile-tail";
    SKILL_NAMES["QUICK_FOUL"] = "quick-foul";
    SKILL_NAMES["PROJECTILE_VOMIT"] = "projectile-vomit";
    SKILL_NAMES["REALLY_STUPID"] = "really-stupid";
    SKILL_NAMES["REGENERATION"] = "regeneration";
    SKILL_NAMES["RIGHT_STUFF"] = "right-stuff";
    SKILL_NAMES["GIVE_AND_GO"] = "running-pass";
    SKILL_NAMES["SAFE_PAIR_OF_HANDS"] = "safe-pair-of-hands";
    // SABOTEUR = "saboteur",
    SKILL_NAMES["SAFE_PASS"] = "safe-pass";
    SKILL_NAMES["SECRET_WEAPON"] = "secret-weapon";
    SKILL_NAMES["SHADOWING"] = "shadowing";
    SKILL_NAMES["STAB"] = "stab";
    SKILL_NAMES["SIDESTEP"] = "sidestep";
    SKILL_NAMES["SNEAKY_GIT"] = "sneaky-git";
    SKILL_NAMES["SPECIALIST"] = "specialist";
    SKILL_NAMES["SPRINT"] = "sprint";
    SKILL_NAMES["STAND_FIRM"] = "stand-firm";
    SKILL_NAMES["STEADY_FOOTING"] = "steady-footing";
    SKILL_NAMES["STAR"] = "star";
    SKILL_NAMES["STRIP_BALL"] = "strip-ball";
    SKILL_NAMES["STRONG_ARM"] = "strong-arm";
    SKILL_NAMES["STUNTY"] = "stunty";
    SKILL_NAMES["SWOOP"] = "swoop";
    SKILL_NAMES["SURE_FEET"] = "sure-feet";
    SKILL_NAMES["SURE_HANDS"] = "sure-hands";
    SKILL_NAMES["TACKLE"] = "tackle";
    SKILL_NAMES["TAUNT"] = "taunt";
    SKILL_NAMES["TAKE_ROOT"] = "take-root";
    SKILL_NAMES["TENTACLES"] = "tentacles";
    SKILL_NAMES["THICK_SKULL"] = "thick-skull";
    SKILL_NAMES["THROW_TEAM_MATE"] = "throw-team-mate";
    SKILL_NAMES["TIMMM_BER"] = "timmm-ber";
    SKILL_NAMES["TITCHY"] = "titchy";
    // TRICKSTER = "trickster",
    SKILL_NAMES["TWO_HEADS"] = "two-heads";
    SKILL_NAMES["UNCHANNELLED_FURY"] = "unchannelled-fury";
    SKILL_NAMES["UNSTEADY"] = "unsteady";
    SKILL_NAMES["VERY_LONG_LEGS"] = "very-long-legs";
    SKILL_NAMES["VIOLENT_INNOVATOR"] = "violent-innovator";
    SKILL_NAMES["WRESTLE"] = "wrestle";
    SKILL_NAMES["DIVING_CATCH"] = "diving-catch";
})(SKILL_NAMES || (exports.SKILL_NAMES = SKILL_NAMES = {}));
var SKILL_TYPE;
(function (SKILL_TYPE) {
    SKILL_TYPE["AGILITY"] = "A";
    SKILL_TYPE["EXTRAORDINARY"] = "E";
    SKILL_TYPE["GENERAL"] = "G";
    SKILL_TYPE["MUTATION"] = "M";
    SKILL_TYPE["PASSING"] = "P";
    SKILL_TYPE["STRENGTH"] = "S";
    SKILL_TYPE["DEVIOUS"] = "D";
    SKILL_TYPE["SPECIAL"] = "SP";
})(SKILL_TYPE || (exports.SKILL_TYPE = SKILL_TYPE = {}));
const SKILL_AGILITY = [
    SKILL_NAMES.CATCH,
    SKILL_NAMES.DEFENSIVE,
    SKILL_NAMES.DIVING_CATCH,
    SKILL_NAMES.DIVING_TACKLE,
    SKILL_NAMES.DODGE,
    SKILL_NAMES.HIT_AND_RUN,
    SKILL_NAMES.JUMP_UP,
    SKILL_NAMES.LEAP,
    SKILL_NAMES.SAFE_PAIR_OF_HANDS,
    SKILL_NAMES.SIDESTEP,
    SKILL_NAMES.SPRINT,
    SKILL_NAMES.SURE_FEET,
];
const SKILL_EXTRAORDINARY = [
    SKILL_NAMES.ALWAYS_HUNGRY,
    SKILL_NAMES.ANIMAL_SAVAGERY,
    SKILL_NAMES.ANIMOSITY,
    // SKILL_NAMES.BALL_AND_CHAIN,
    SKILL_NAMES.BONE_HEAD,
    // SKILL_NAMES.BOMBARDIER,
    SKILL_NAMES.BLOODLUST,
    SKILL_NAMES.BREATHE_FIRE,
    SKILL_NAMES.CHAINSAW,
    SKILL_NAMES.DECAY,
    SKILL_NAMES.DRUNKARD,
    // SKILL_NAMES.HATRED,
    SKILL_NAMES.HYPNOTIC_GAZE,
    // SKILL_NAMES.INSIGNIFICANT,
    // SKILL_NAMES.KICK_TEAMMATE,
    SKILL_NAMES.LONER,
    SKILL_NAMES.MY_BALL,
    SKILL_NAMES.NO_HANDS,
    SKILL_NAMES.PICK_ME_UP,
    SKILL_NAMES.PLAGUE_RIDDEN,
    SKILL_NAMES.POGO_STICK,
    SKILL_NAMES.PROJECTILE_VOMIT,
    SKILL_NAMES.REALLY_STUPID,
    SKILL_NAMES.REGENERATION,
    SKILL_NAMES.RIGHT_STUFF,
    SKILL_NAMES.SECRET_WEAPON,
    SKILL_NAMES.STAB,
    SKILL_NAMES.STUNTY,
    SKILL_NAMES.SWOOP,
    SKILL_NAMES.TAKE_ROOT,
    SKILL_NAMES.THROW_TEAM_MATE,
    SKILL_NAMES.TIMMM_BER,
    SKILL_NAMES.TITCHY,
    // SKILL_NAMES.TRICKSTER,
    SKILL_NAMES.UNCHANNELLED_FURY,
    SKILL_NAMES.UNSTEADY,
];
const SKILL_GENERAL = [
    SKILL_NAMES.BLOCK,
    SKILL_NAMES.DAUNTLESS,
    SKILL_NAMES.FEND,
    SKILL_NAMES.FRENZY,
    // SKILL_NAMES.KICK,
    SKILL_NAMES.PRO,
    SKILL_NAMES.STEADY_FOOTING,
    SKILL_NAMES.STRIP_BALL,
    SKILL_NAMES.SURE_HANDS,
    SKILL_NAMES.TACKLE,
    SKILL_NAMES.TAUNT,
    SKILL_NAMES.WRESTLE,
];
const SKILL_MUTATION = [
    SKILL_NAMES.BIG_HAND,
    SKILL_NAMES.CLAW,
    SKILL_NAMES.DISTURBING_PRESENCE,
    SKILL_NAMES.EXTRA_ARMS,
    SKILL_NAMES.FOUL_APPEARANCE,
    SKILL_NAMES.HORNS,
    SKILL_NAMES.IRON_HARD_SKIN,
    SKILL_NAMES.MONSTROUS_MOUTH,
    SKILL_NAMES.PREHENSILE_TAIL,
    SKILL_NAMES.TENTACLES,
    SKILL_NAMES.TWO_HEADS,
    SKILL_NAMES.VERY_LONG_LEGS,
];
const SKILL_PASSING = [
    SKILL_NAMES.ACCURATE,
    SKILL_NAMES.CANNONEER,
    SKILL_NAMES.CLOUD_BURSTER,
    SKILL_NAMES.DUMP_OFF,
    SKILL_NAMES.GIVE_AND_GO,
    SKILL_NAMES.HAIL_MARY_PASS,
    // SKILL_NAMES.LEADER,
    SKILL_NAMES.NERVES_OF_STEEL,
    SKILL_NAMES.ON_THE_BALL,
    SKILL_NAMES.PASS,
    SKILL_NAMES.PUNT,
    SKILL_NAMES.SAFE_PASS,
];
const SKILL_STRENGTH = [
    SKILL_NAMES.ARM_BAR,
    SKILL_NAMES.BRAWLER,
    SKILL_NAMES.BREAK_TACKLE,
    SKILL_NAMES.BULLSEYE,
    SKILL_NAMES.GRAB,
    SKILL_NAMES.GUARD,
    SKILL_NAMES.JUGGERNAUT,
    SKILL_NAMES.MIGHTY_BLOW,
    // SKILL_NAMES.MULTIPLE_BLOCK,
    SKILL_NAMES.STAND_FIRM,
    SKILL_NAMES.STRONG_ARM,
    SKILL_NAMES.THICK_SKULL,
];
const SKILL_DEVIOUS = [
    SKILL_NAMES.DIRTY_PLAYER,
    SKILL_NAMES.EYE_GOUGE,
    SKILL_NAMES.FUMBLEROOSKIE,
    // SKILL_NAMES.LETHAL_FLIGHT,
    SKILL_NAMES.LONE_FOULER,
    SKILL_NAMES.PILE_DRIVER,
    SKILL_NAMES.PUT_THE_BOOT_IN,
    SKILL_NAMES.QUICK_FOUL,
    // SKILL_NAMES.SABOTEUR,
    SKILL_NAMES.SHADOWING,
    SKILL_NAMES.SNEAKY_GIT,
    SKILL_NAMES.VIOLENT_INNOVATOR,
];
const SKILL_SPECIAL = [
    SKILL_NAMES.BIG_GUY,
    SKILL_NAMES.SPECIALIST,
    SKILL_NAMES.STAR,
];
const buildSkillsByType = (skills, type) => {
    return skills.reduce((acc, skill) => {
        acc[skill] = type;
        return acc;
    }, {});
};
const SKILLS = {
    ...buildSkillsByType(SKILL_AGILITY, SKILL_TYPE.AGILITY),
    ...buildSkillsByType(SKILL_EXTRAORDINARY, SKILL_TYPE.EXTRAORDINARY),
    ...buildSkillsByType(SKILL_GENERAL, SKILL_TYPE.GENERAL),
    ...buildSkillsByType(SKILL_MUTATION, SKILL_TYPE.MUTATION),
    ...buildSkillsByType(SKILL_PASSING, SKILL_TYPE.PASSING),
    ...buildSkillsByType(SKILL_STRENGTH, SKILL_TYPE.STRENGTH),
    ...buildSkillsByType(SKILL_DEVIOUS, SKILL_TYPE.DEVIOUS),
    ...buildSkillsByType(SKILL_SPECIAL, SKILL_TYPE.SPECIAL),
};
exports.SKILLS = SKILLS;
const SKILL_IS_2025 = Object.values(SKILL_NAMES).reduce((acc, id) => {
    acc[id] = false;
    return acc;
}, {});
exports.SKILL_IS_2025 = SKILL_IS_2025;
SKILL_IS_2025[SKILL_NAMES.BLOCK] = true;
// Strip Ball: When a player with this skill pushes an opposing player during a Block, they will cause the opposing player to drop the ball in square they are pushed back to, even if the opposing player is not Knocked Down.
// Sure Hands: A player with Sure Hands is allowed to re-roll the result if they fail to pick up the ball. In addition, the Strip Ball skill does not work against a player with this skill.
function useSkill(player, skillId, date = -1, info = null) {
    if (!SKILLS.hasOwnProperty(skillId)) {
        throw `useSkill Skill '${skillId}' does not exist`;
    }
    const playerSkills = player.skills;
    if (!playerSkills) {
        return false;
    }
    const skill = playerSkills.find((s) => s.skill_id === skillId);
    if (!skill) {
        return false;
    }
    skill.date_next =
        date === -1
            ? new Date(Date.now() + (0, time_1.getTime)(time_1.TYPE_TIMER.ACTION) * 1000)
            : date;
    skill.info = info;
}
function getSkill(player, skillId, info = null) {
    if (!SKILLS.hasOwnProperty(skillId)) {
        throw `getSkill Skill '${skillId}' does not exist`;
    }
    const playerSkills = player.skills;
    if (!playerSkills) {
        return false;
    }
    const skill = playerSkills.find((s) => s.skill_id === skillId && (info ? s.info === info : true));
    return !!skill ? skill : false;
}
function hasUsedSkill(player, skill) {
    const hasSkill = getSkill(player, skill);
    if (hasSkill === false) {
        return false;
    }
    return hasSkill.date_next !== null ? true : false;
}
function hasSkill(player, skillId, withDate = false, checkActivated = true, info = null) {
    const skill = getSkill(player, skillId, info);
    const isActivated = (skill) => checkActivated && isActivableSkills(skillId)
        ? skill.active == null || skill.active === SKILL_INFO_ACTIVE
            ? true
            : false
        : true;
    if (withDate) {
        if (skill && skill.date_next) {
            if (new Date(skill.date_next) < new Date(Date.now())) {
                skill.date_next = null;
                return isActivated(skill);
            }
        }
        return skill && skill.date_next === null ? isActivated(skill) : false;
    }
    else {
        return skill ? isActivated(skill) : false;
    }
}
const getPlayersWithSkill = (players, skillId) => {
    const list = [];
    players.forEach((player) => {
        if (hasSkill(player, skillId)) {
            list.push(player);
        }
    });
    return list;
};
exports.getPlayersWithSkill = getPlayersWithSkill;
const hasSkillDisplayableInfo = (skillId) => {
    const activables = [
        SKILL_NAMES.BLOODLUST,
        SKILL_NAMES.LONER,
        SKILL_NAMES.ANIMOSITY,
        SKILL_NAMES.CHAINSAW,
        SKILL_NAMES.DIRTY_PLAYER,
        SKILL_NAMES.MIGHTY_BLOW,
    ];
    return activables.includes(skillId);
};
exports.hasSkillDisplayableInfo = hasSkillDisplayableInfo;
const isActivableSkills = (skill) => {
    const activables = [
        SKILL_NAMES.BRAWLER,
        SKILL_NAMES.DUMP_OFF,
        SKILL_NAMES.JUGGERNAUT,
        SKILL_NAMES.PILE_DRIVER,
        SKILL_NAMES.TENTACLES,
        SKILL_NAMES.WRESTLE,
        SKILL_NAMES.SHADOWING,
    ];
    return activables.includes(skill);
};
exports.isActivableSkills = isActivableSkills;
const isSelectPlayersSkills = (skill) => {
    const activables = [SKILL_NAMES.DIVING_TACKLE];
    return activables.includes(skill);
};
exports.isSelectPlayersSkills = isSelectPlayersSkills;
const hasSkillForPlayer = (playerWithSkill, playerTarget, skillId) => {
    if (hasSkill(playerWithSkill, skillId)) {
        const skill = getSkill(playerWithSkill, skillId);
        const data = skill ? skill?.data || "" : "";
        if (skill && data.includes(playerTarget.id)) {
            return true;
        }
    }
    return false;
};
exports.hasSkillForPlayer = hasSkillForPlayer;
function getStarLimit(teamPlayers) {
    const specialists = getPlayersWithSkill(teamPlayers, SKILL_NAMES.SPECIALIST).length;
    const extra = specialists - SPECIALIST_LIMIT > 0 ? specialists - SPECIALIST_LIMIT : 0;
    return STAR_LIMIT - extra;
}
function getSpecialistLimit(teamPlayers) {
    const stars = getPlayersWithSkill(teamPlayers, SKILL_NAMES.STAR).length;
    const extra = STAR_LIMIT - stars;
    return SPECIALIST_LIMIT + extra;
}
// Migration 2025: indique si une compétence legacy existe dans la nouvelle liste 2025
const SKILL_MIGRATION_2025 = (() => {
    const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]/gi, "");
    const migrated = new Set(newSkills_1.newSkills.map((s) => normalize(s.name)));
    const map = {};
    Object.values(SKILL_NAMES).forEach((id) => {
        map[id] = migrated.has(normalize(id));
    });
    return map;
})();
exports.SKILL_MIGRATION_2025 = SKILL_MIGRATION_2025;
function getSkillLimitSizeTeam(player, teamPlayers) {
    let limitSkill = null;
    let skillToCheck = null;
    if (hasSkill(player, SKILL_NAMES.BIG_GUY)) {
        skillToCheck = SKILL_NAMES.BIG_GUY;
        limitSkill = BIG_GUY_LIMIT;
    }
    else if (hasSkill(player, SKILL_NAMES.STAR)) {
        skillToCheck = SKILL_NAMES.STAR;
        limitSkill = getStarLimit(teamPlayers);
    }
    else if (hasSkill(player, SKILL_NAMES.SPECIALIST)) {
        skillToCheck = SKILL_NAMES.SPECIALIST;
        limitSkill = getSpecialistLimit(teamPlayers);
    }
    if (skillToCheck) {
        const nb = getPlayersWithSkill(teamPlayers, skillToCheck).length;
        if (limitSkill && nb >= limitSkill) {
            return skillToCheck;
        }
    }
    return null;
}
function getSkillDisplayedWithCarrer() {
    return [SKILL_NAMES.BIG_GUY, SKILL_NAMES.STAR, SKILL_NAMES.SPECIALIST];
}
function getNoTurnoverSkill() {
    return [
        SKILL_NAMES.DAUNTLESS,
        SKILL_NAMES.BONE_HEAD,
        SKILL_NAMES.REALLY_STUPID,
        SKILL_NAMES.ANIMAL_SAVAGERY,
        SKILL_NAMES.ANIMOSITY,
        SKILL_NAMES.TAKE_ROOT,
        SKILL_NAMES.UNCHANNELLED_FURY,
        SKILL_NAMES.BLOODLUST,
        SKILL_NAMES.DUMP_OFF,
        SKILL_NAMES.HYPNOTIC_GAZE,
        SKILL_NAMES.FOUL_APPEARANCE,
        SKILL_NAMES.JUMP_UP,
    ];
}
function isNoTurnoverSkill(skill) {
    const skillId = typeof skill === "object" && "skill_id" in skill ? skill.skill_id : skill;
    const noTd = getNoTurnoverSkill();
    // TODO : Check if this is correct
    return noTd.includes(skillId);
}
/*
DISTURBING PRESENCE
 When an opposition player performs either a
 Pass action,
 a Throw Team- mate action
 or a Throw Bomb Special action,
 or attempts to either interfere with a pass
 or to catch the ball,
 they must apply a -1 modifier to the test for each player on your team with this Skill
 that is within three squares of them,
 even if the player with this Skill is Prone,
 Stunned or has lost their Tackle Zone. */
function getDisturbingPresenceMalus(player, players) {
    const malus = players.filter((p) => {
        return (p.teamId !== player.teamId &&
            (0, status_1.hasStatusOnField)(p) &&
            hasSkill(p, SKILL_NAMES.DISTURBING_PRESENCE) &&
            (0, calcul_1.distanceSquares)(player, p, 3));
    }).length;
    return malus;
}
const isSpecialSkill = (skill) => {
    // TODO : Check if this is correct
    const skillId = typeof skill === "object" && "skill_id" in skill ? skill.skill_id : skill;
    return SKILLS[skillId] === SKILL_TYPE.SPECIAL;
};
exports.isSpecialSkill = isSpecialSkill;
const helpSkillsToDisplay = {
    [SKILL_NAMES.BLOCK]: { actif: false, color: "#FF0000" },
    [SKILL_NAMES.DEFENSIVE]: { actif: false, color: "#0000FF" },
    [SKILL_NAMES.DISTURBING_PRESENCE]: { actif: false, color: "#00FF44" },
    [SKILL_NAMES.DODGE]: { actif: false, color: "#FFFF00" },
    [SKILL_NAMES.GUARD]: { actif: false, color: "#555555" },
    [SKILL_NAMES.SHADOWING]: { actif: false, color: "#995500" },
    [SKILL_NAMES.STAND_FIRM]: { actif: false, color: "#550099" },
    [SKILL_NAMES.TACKLE]: { actif: false, color: "#f200ff" },
};
exports.helpSkillsToDisplay = helpSkillsToDisplay;
const hasToAgilityJumpUp = (player) => {
    const skill = getSkill(player, SKILL_NAMES.JUMP_UP);
    if (skill && skill.date_next) {
        if (new Date(skill.date_next) > new Date(Date.now())) {
            return true;
        }
    }
    return false;
};
exports.hasToAgilityJumpUp = hasToAgilityJumpUp;
